import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useDispatch, useSelector } from 'react-redux';
import { selectObjectLanguageById } from '../../../../../redux/modules/data/objectLanguagesSlice';
import { getLinkOfObject, recentlyViewedObject } from '../../../../../redux/modules/data/objectsSlice';
import { DragIcon, PlayIcon, RestrictedIcon } from '../../../../misc/icons/Icons';
import FavListsPopover from './FavoritesPopover';

const ObjectRow = ({ object, isDraggable = false }) => {
	const dispatch = useDispatch();

	const objectLanguage = useSelector((state) => selectObjectLanguageById(state, object.objectlaguage_id));

	const url = getLinkOfObject(object);

	let thumbUrl = null;
	if (object.type === 'doc' || object.type === 'link') {
		thumbUrl = `${process.env.REACT_APP_API_BASE_URL}/${object.thumb}`;
	} else if (object.type === 'MAM') {
		thumbUrl = `${process.env.REACT_APP_MAM_THUMB_BASE_URL}${object.thumb}`;
	}

	const handleClick = (e) => {
		dispatch(recentlyViewedObject({ objectId: object.id }));
		if (!url) {
			e.preventDefault();
		}
	};

	return (
		<div className="relative flex items-center w-full bg-white h-34 can-hover:hover:bg-gray-50">
			{!url && (<div className="absolute shadow-md top-3 left-3 w-28 text-center bg-oly-yellow-default text-oly-gray-footerbar rounded-sm text-sm z-10">iPad only</div>)}
			<a
				href={url ?? '#'}
				target="_blank"
				className={`${!url ? 'opacity-30 bg-oly-gray-lightestAlpha45' : ''} flex items-center justify-start flex-grow h-full gap-2.5 p-3 pr-16 text-left sm:p-5 sm:pr-16 ${!object.restricted === '1' ? 'xl:pr-38' : 'xl:pr-56'} sm:gap-8 focus:outline-none`}
				aria-labelledby={`open-object-${object.title1 + object.title2}`}
				rel="noreferrer"
				onClick={(e) => handleClick(e)}
			>
				<div className="relative flex flex-shrink-0 w-40 h-full sm:w-44">
					<LazyLoadImage
						alt=""
						src={thumbUrl}
						placeholderSrc={`${process.env.PUBLIC_URL}/images/placeholder.png`}
						className="object-contain w-full h-full"
						wrapperClassName="w-full !bg-no-repeat !bg-contain !bg-center"
					/>
					{object.video && <PlayIcon className="absolute inset-0 w-8 h-8 m-auto text-white" />}
				</div>
				<div className="flex flex-col justify-between h-full text-oly-gray-darkest">
					<span className="text-[0.9375rem] font-semibold leading-4 sm:text-[1.125rem] sm:leading-5 line-clamp-3 sm:line-clamp-2">
						{object.title1}
						{' '}
						{object.title2}
					</span>
					<div className="flex flex-col gap-1">
						<span className="text-[0.8125rem] line-clamp-1 sm:text-[0.9375rem]">
							{object.subtitle}
						</span>
						<span className="text-[0.8125rem] line-clamp-1 sm:text-[0.9375rem] text-oly-gray-dark uppercase">
							{object?.updated_at ? `${object?.updated_at}` : ''}
							{objectLanguage?.title ? ` • ${objectLanguage?.title}` : ''}
							{object?.file_type ? ` • ${object?.file_type}` : ''}
							{object?.type === 'link' ? ` • ${object?.type}` : ''}
						</span>
					</div>
				</div>
			</a>
			<div className="absolute right-0 flex flex-col justify-end flex-shrink-0 h-full pb-2 pr-3 xl:pb-0 xl:flex-row xl:gap-6 xl:h-auto">
				{object.restricted === '1' && (
					<div className="flex items-center flex-shrink-0 order-1 p-2 xl:order-1 text-oly-gray-darkest">
						<RestrictedIcon className="w-6 h-6 xl:w-8 xl:h-8" />
					</div>
				)}
				<div className="order-3 xl:order-2">
					<FavListsPopover isObjectRow object={object} />
				</div>
				{isDraggable && (
					<div className="flex items-center flex-shrink-0 order-2 p-2 rounded-lg xl:order-3 text-oly-gray-darkest drag-control">
						<DragIcon className="w-6 h-6 xl:w-8 xl:h-8" />
					</div>
				)}
			</div>
		</div>
	);
};

export default ObjectRow;
